var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    uuid: "e645986d-a395-46f2-9d2a-6944ec235fb7",
    version: "0.0.1",
    organization: "Tina",
    project: "AnimatorWebsiteIcon6",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon6",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/0f9a2fb9-3bf3-4c64-9b2d-1a9af15c3253/5c51f21e1f76d3ec3900c58fb722be9bdc65c090/",
    core: "4.5.1",
    title: "Deco3",
    type: "haiku",
    relpath: "code/deco3/code.js"
  },
  options: {},
  states: {},
  eventHandlers: {},
  timelines: {
    Default: {
      "haiku:Deco3-0c407b0457d72f75": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 14.151,
        "sizeAbsolute.y": 14.495,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:7b2afc445feb": {
        "sizeAbsolute.y": 10,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 11,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeMode.y": 1,
        "translation.x": 6.8469999999999995,
        "translation.y": 6.795999999999999,
        "style.zIndex": 4,
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "linear" },
          "667": { value: 6.284, edited: true }
        }
      },
      "haiku:7ebc19412978": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:3746571d2057": {
        fill: "#FFAC39",
        "translation.x": -9,
        "translation.y": -51
      },
      "haiku:e3a07ae0644b": {
        x: 10.6641016,
        y: 52.1805668,
        width: 8,
        height: 8,
        rx: 2,
        "translation.x": 30.054901,
        "translation.y": 0.194718,
        "rotation.z": 0.523599
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Deco3-0c407b0457d72f75",
      "haiku-title": "Deco3"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "7b2afc445feb",
          "haiku-title": "deco3",
          "haiku-source":
            "designs/AnimatorWebsiteIcon6.sketch.contents/slices/deco3.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: {
              "haiku-id": "7ebc19412978",
              "haiku-title": "Page-1",
              id: "c008d085398b"
            },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "3746571d2057",
                  "haiku-title": "Help-icon",
                  id: "c747d05e093b"
                },
                children: [
                  {
                    elementName: "rect",
                    attributes: {
                      "haiku-id": "e3a07ae0644b",
                      "haiku-title": "deco3",
                      id: "29aa99b68293"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon6/code/deco3/code.js
// module id = 458
// module chunks = 127651196306611